import { useEffect, useRef } from "react";

export function useOnce(func: () => void) {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;

    const cleanup = func();
    ran.current = true;

    return cleanup;
  }, [func]);
}
